import { styled, keyframes } from '@compiled/react';
import { token } from '@atlaskit/tokens';

const fromPositionX = -150;
const toPositionX = 600;

const shimmer = keyframes({
	'0%': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		backgroundPosition: `${fromPositionX}px 0`,
	},
	'100%': {
		backgroundPosition: `${toPositionX}px 0`,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- To migrate as part of go/ui-styling-standard
export const SkeletonBackground = styled.div({
	animationDuration: '1s',
	animationFillMode: 'forwards',
	animationIterationCount: 'infinite',
	animationName: shimmer,
	animationTimingFunction: 'linear',

	backgroundColor: token('color.skeleton'),

	backgroundImage: `linear-gradient( to right, ${token('color.skeleton')} 10%, ${token('color.skeleton.subtle')} 30%, ${token('color.skeleton')} 50% )`,
	backgroundRepeat: 'no-repeat',
	overflow: 'hidden',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
	borderRadius: token('radius.small', '3px'),
});

// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FlexContainer = styled.div<{ marginBottom?: number }>(({ marginBottom = 0 }) => ({
	display: 'flex',
	alignItems: 'center',
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	marginBottom: `${marginBottom}px`,
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Avatar = styled(SkeletonBackground)({
	width: token('space.300'),
	height: token('space.300'),
	borderRadius: token('radius.full'),
	flexShrink: 0,
	marginRight: token('space.150'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Title = styled(SkeletonBackground)({
	width: '152px',
	height: token('space.200'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AttributeName = styled(SkeletonBackground)({
	marginTop: token('space.050'),
	marginRight: token('space.100'),
	marginBottom: token('space.050'),
	marginLeft: 0,
	height: token('space.200'),
	width: '168px',
	flex: '0 0 auto',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AttributeValue = styled(SkeletonBackground)({
	marginTop: token('space.050'),
	marginRight: 0,
	marginBottom: token('space.050'),
	marginLeft: 0,
	height: token('space.200'),
	flex: '1 1 auto',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LinkedIssueCard = styled(SkeletonBackground)({
	marginTop: token('space.050'),
	marginRight: token('space.100'),
	marginBottom: token('space.050'),
	marginLeft: 0,
	height: token('space.400'),
});
